import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import WorkflowsIndex from './index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/workflows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'workflows_index',
          component: WorkflowsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
